import { render, staticRenderFns } from "./CommonQuestion.vue?vue&type=template&id=05e892ca&"
import script from "./CommonQuestion.vue?vue&type=script&lang=js&"
export * from "./CommonQuestion.vue?vue&type=script&lang=js&"
import style0 from "./CommonQuestion.vue?vue&type=style&index=0&id=05e892ca&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports